import Api from 'src/services/api'

const state = {
  restaurants: []
}

const mutations = {
  SET_RESTAURANTS (state, payload = []) {
    payload = payload
      .filter(o => o.extra && !o.extra.exclude_from_atbl)
      .sort((a, b) => {
        return a.name.localeCompare(b.name)
      })
    state.restaurants = payload
  }
}

const actions = {
  fetchRestaurants ({ commit }, payload = {}) {
    return Api.fetchSitesList({
      limit: 99,
      ...payload
    })
      .then(
        ({ data }) => {
          commit('SET_RESTAURANTS', data)
          return data
        },
        (e) => {
          let { response = {} } = e
          commit('SET_RESTAURANTS')
          return response.data
        }
      )
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
